<template>
	<n-link
		:to="{ name: 'article', params: { category: article.category, slug: article.slug } }"
		:title="article.title"
		class="article-card"
	>
		<v-card
			:elevation="$attrs.elevation || 0"
			tile
		>
			<v-row no-gutters>
				<v-col
					v-resize="onResize"
					cols="6"
					sm="5"
					md="3"
				>
					<z-img
						:storage="article.featured"
						:alt="article.title"
						max-width="100%"
						:max-height="maxHeight"
					/>
				</v-col>
				<v-col
					cols="6"
					sm="7"
					md="9"
					class="d-flex flex-column pl-4 pt-md-5"
				>
					<div class="article-info">
						{{ article.title }}
					</div>
					<div class="d-flex align-center">
						<v-icon
							class="mr-1"
							color="rgb(237,28,36)"
							small
						>
							mdi-clock
						</v-icon>
						{{ date(article.created_at || null) }}
					</div>
					<div
						v-if="showReadButton"
						class="mt-auto d-flex"
					>
						<v-btn
							class="btn-red-gradient white--text flex-grow-1 flex-lg-grow-0"
							depressed
							tile
						>
							อ่าน
						</v-btn>
						<v-btn
							class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
							depressed
							tile
						>
							<v-icon>
								mdi-arrow-right
							</v-icon>
						</v-btn>
					</div>
				</v-col>
			</v-row>
		</v-card>
	</n-link>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
	props: {
		article: {
			type: Object,
			default: () => ({})
		},
		extraHeight: {
			type: Number,
			default: 0
		},
		showReadButton: {
			type: Boolean,
			default: false
		}
	},
	data:() => ({
		maxHeight: '100%',
		dateFormat: new Intl.DateTimeFormat('th-TH', { dateStyle: 'long' })
	}),
	computed: {
		...mapGetters({
			getLocation: 'getLocation',
			getProperty: 'property/getProperty',
			isFavorite: 'property/isFavorite'
		})
	},
	watch: {
		// xs () {
		// 	this.onResize()
		// }
	},
	created() {

	},
	methods: {
		...mapActions({
			addOrRemoveFavorite: 'property/addOrRemoveFavorite'
		}),

		onResize () {
			if (process.client) {
				this.maxHeight = (window.innerWidth > 959 ? 165 : (window.innerWidth > 599 ? 195 : 150)) + this.extraHeight
			}
		},

		date (ts) {
			if (ts) {
				return this.dateFormat.format(ts.seconds * 1000)
			}

			return ''
		}
	},
}
</script>

<style lang="scss" scoped>
.article-card {
	font-size: 0.9rem;
	font-weight: bold;
	text-decoration: none;
	color: #000;

	.article-info {
		min-height: 70px;
    max-height: 70px;
    overflow: hidden;
	}
}
</style>
